import React from 'react'
import Avatar from '../../images/Avatar.png'

const AvatarCard = ({ user }) => {
    return (
        <div className='d-flex justify-content-start'>
            <div><img src={Avatar} alt='' /></div>
            <div className='ml-2'>
                <div><strong className='f14'>{user?.firstName} {user?.lastName}</strong></div>
                <div className='mt--5'><span className='text-secondary f12'>{user?.mission}</span></div>
            </div>
        </div>
    )
}

export default AvatarCard
